/* eslint-disable react/self-closing-comp */
/* eslint-disable vars-on-top */
/* eslint-disable prefer-const */
/* eslint-disable no-var */
/* eslint-disable no-redeclare */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

import React from 'react';
import PropTypes from 'prop-types';

import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux'

import BackButton from '../../components/BackButton/BackButton';
import styles from "./ApproveRejectBooking.module.css";
import  ApproveRejectBooking  from "../../components/ApproveRejectBooking/ApproveRejectBooking";
import { CustomTab } from '../../atomicComponents';
import UserInfoPanel from '../../atomicComponents/UserInfoPanel/UserInfoPanel';

function ReportNoPOPage({product}) {
  const history = useHistory();
  const redirectToProcessPage = () => {
    history.push('/home');
  };


  return (
    <>
      <div className={styles.container} style={{ boxSizing: 'border-box' }}>
          <div className={styles.backButtonLastRefreshedDateWrapper} style={{display:"none"}}>

          <BackButton
            action="Home"
            handleClick={redirectToProcessPage}
          />
        </div>
        <div className={styles.processHeader}>
          <div className={styles.CustomTabClass}>
            <CustomTab title="Manager Approval" withOutCount isSelected />
          </div>
          <div className={styles.processTopbar} style={{}}>

          <UserInfoPanel
                userInfo={[
                  {
                    Name: "Rutuja Chavan",
                    "SAP ID": 122366,
                    "BC No": "122366",
                    LOC: "Engineering and Research Center",
                  },
                ]}
              />
              </div>
 </div>
     
        <ApproveRejectBooking redirectToProcessPage={redirectToProcessPage}/>

      </div>
    </>
  )
}
const mapStateToProps = state => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch) => ({

});
ReportNoPOPage.propTypes = {

  product: PropTypes.object,

};
export default connect(mapStateToProps, mapDispatchToProps)(ReportNoPOPage); 
